import qmpSettings from './front';

export const projectSettings = qmpSettings;
